<div>
  <a class="link-color" (click)="onClick('TaskAssignee')">{{ displayText }}</a>
   <a class="link-color" (click)="onClick('TaskAssignee')">(+)</a>
<!--  or  <a class="link-color" (click)="onClick('TaskRole')">Role</a>-->
</div>
